import useWindowSize from "./useWindowSize"
import ScssVariables from "../../Styles/DefaultTheme/_variables.scss"

const tabletWidth = parseInt(ScssVariables.tabletWidth.substr(0, ScssVariables.tabletWidth.length-2))

export default function useIsMobile() {
  const [windowWidth] = useWindowSize()
  return windowWidth <= tabletWidth-1
}